import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  searchRecord: null,
  orderDetailInfo: null,
}

const orderSlice = createSlice({
  name: 'logistics',
  initialState: initialState,
  reducers: {
    setOrderSearchRecord(state, action) {
      return {
        ...state,
        searchRecord: action.payload,
      }
    },
  },
})

export const { setOrderSearchRecord } = orderSlice.actions
export default orderSlice.reducer
